import { z } from 'zod';

export const ALL_STATUSES = [
  'OP',
  'CO',
  'PE',
  'CA',
] as const;

export const paymentStatus = z.enum(ALL_STATUSES);

export type PaymentStatus = z.infer<typeof paymentStatus>;

export const OP = ['OP'] as const;
